'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var PaginationList = require('./PaginationList.js');
var PaginationItem = require('./PaginationItem.js');
var PaginationListItem = require('./PaginationListItem.js');
var PaginationArrow = require('./PaginationArrow.js');
var PaginationEllipsis = require('./PaginationEllipsis.js');
var usePagination = require('./usePagination.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["defaultPage", "page", "boundaryCount", "count", "siblingCount", "renderItem", "isDisabled", "onChange", "getAriaLabel", "showLastPageButton", "showFirstPageButton", "hidePrevPageButton", "hideNextPageButton", "children", "className"];
/**
 * Pagination
 *
 * The pagination is a user interface pattern that divides content into separate
 * pages. Renders a `<nav />` element by default.
 */
var Pagination = react.forwardRef(function (props, ref) {
  var styles = react.useMultiStyleConfig('Pagination', props);
  var _omitThemingProps = react.omitThemingProps(props),
    defaultPageProp = _omitThemingProps.defaultPage,
    pageProp = _omitThemingProps.page,
    boundaryCountProp = _omitThemingProps.boundaryCount,
    countProp = _omitThemingProps.count,
    siblingCountProp = _omitThemingProps.siblingCount,
    renderItemProp = _omitThemingProps.renderItem,
    isDisabledProp = _omitThemingProps.isDisabled,
    onChangeProp = _omitThemingProps.onChange,
    getAriaLabelProp = _omitThemingProps.getAriaLabel,
    showLastPageButton = _omitThemingProps.showLastPageButton,
    showFirstPageButton = _omitThemingProps.showFirstPageButton,
    hidePrevPageButton = _omitThemingProps.hidePrevPageButton,
    hideNextPageButton = _omitThemingProps.hideNextPageButton,
    children = _omitThemingProps.children,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var _usePagination = usePagination.usePagination({
      defaultPage: defaultPageProp,
      page: pageProp,
      boundaryCount: boundaryCountProp,
      count: countProp,
      siblingCount: siblingCountProp,
      renderItem: renderItemProp,
      isDisabled: isDisabledProp,
      onChange: onChangeProp,
      getAriaLabel: getAriaLabelProp
    }),
    page = _usePagination.page,
    count = _usePagination.count,
    handleClick = _usePagination.handleClick,
    getAriaLabel = _usePagination.getAriaLabel,
    itemList = _usePagination.itemList,
    renderItem = _usePagination.renderItem,
    isDisabled = _usePagination.isDisabled;
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.nav, _extends__default["default"]({
    className: utils.cx('chakra-pagination', className),
    role: "pagination",
    __css: styles.container
  }, rest), /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, children ? children : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, showFirstPageButton && renderItem(PaginationArrow.PaginationFirstArrow, {
    onClick: function onClick(event) {
      return handleClick(event, 1);
    },
    'aria-label': getAriaLabel(1, 'first'),
    isDisabled: isDisabled || page === 1
  }, 1), !hidePrevPageButton && renderItem(PaginationArrow.PaginationPrevArrow, {
    onClick: function onClick(event) {
      return handleClick(event, page - 1);
    },
    'aria-label': getAriaLabel(page - 1, 'prev'),
    isDisabled: isDisabled || page === 1
  }, page - 1), /*#__PURE__*/React__default["default"].createElement(PaginationList.PaginationList, null, itemList.map(function (item) {
    if (item === 'start-ellipsis' || item === 'end-ellipsis') {
      return /*#__PURE__*/React__default["default"].createElement(PaginationListItem.PaginationListItem, {
        key: item
      }, /*#__PURE__*/React__default["default"].createElement(PaginationEllipsis.PaginationEllipsis, null));
    }
    if (typeof item === 'number') {
      return /*#__PURE__*/React__default["default"].createElement(PaginationListItem.PaginationListItem, {
        key: item
      }, renderItem(PaginationItem.PaginationItem, {
        onClick: function onClick(event) {
          return handleClick(event, item);
        },
        'aria-label': getAriaLabel(item, 'page', item === page),
        isActive: item === page,
        isDisabled: isDisabled
      }, item));
    }
  })), !hideNextPageButton && renderItem(PaginationArrow.PaginationNextArrow, {
    onClick: function onClick(event) {
      return handleClick(event, page + 1);
    },
    'aria-label': getAriaLabel(page + 1, 'next'),
    isDisabled: isDisabled || page + 1 > count
  }, page + 1), showLastPageButton && renderItem(PaginationArrow.PaginationLastArrow, {
    onClick: function onClick(event) {
      return handleClick(event, count);
    },
    'aria-label': getAriaLabel(count, 'last'),
    isDisabled: isDisabled || page === count
  }, count))));
});
Pagination.displayName = 'Pagination';
exports.Pagination = Pagination;